import React from 'react'
import ReactDOM from 'react-dom'
import './styles/index.sass'
import App from "./App";
import {crossDomainStorage} from "./utils/crossDomainStorage";

console.log = console.warn = console.error = () => {}; // Отключение сообщений об ошибках в консоль



crossDomainStorage()
ReactDOM.render(<App/>, document.getElementById('root'))
